import { useState } from "react";

const AI_GENERAL_KNOWLEDGE_STREAM_ENDPOINT =
  process.env.REACT_APP_AI_GENERAL_KNOWLEDGE_STREAM_ENDPOINT;

export const useAIGeneralKnowledgeStream = () => {
  const [loadingStreaming, setLoadingStreaming] = useState(false);
  const [answerStreaming, setAnswerStreaming] = useState("");
  const [reasoningStreaming, setReasoningStreaming] = useState("");
  const [isThinking, setIsThinking] = useState(false);

  const startStreaming = async (prompt) => {
    if (!prompt) return;

    setLoadingStreaming(true);
    setAnswerStreaming("");
    setReasoningStreaming("");
    setIsThinking(true);

    try {
      const response = await fetch(AI_GENERAL_KNOWLEDGE_STREAM_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ACTION_SECRET: "Nhk03CBnel",
        },
        body: JSON.stringify({
          input: { prompt, model: "gpt-4" },
        }),
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk.split("\n");

        for (const line of lines) {
          if (line.startsWith("data: ")) {
            const dataText = line.replace("data: ", "").trim();

            if (dataText === "[DONE]") break;

            try {
              const parsed = JSON.parse(dataText);

              if (parsed.thinking) {
                setReasoningStreaming(parsed.thinking);
              }

              if (parsed.answer) {
                setIsThinking(false);
                setAnswerStreaming((prev) => prev + parsed.answer);
              }
            } catch (e) {
              console.error("Error parseando chunk:", e);
            }
          }
        }
      }
    } catch (error) {
      setAnswerStreaming("Error: " + error.message);
      return "Error: " + error.message;
    } finally {
      setLoadingStreaming(false);
    }
  };

  const clearStreaming = () => {
    setAnswerStreaming("");
    setReasoningStreaming("");
  };

  return {
    startStreaming,
    clearStreaming,
    loadingStreaming,
    answerStreaming,
    reasoningStreaming,
    isThinking,
  };
};
